import { create } from 'zustand';
import axiosInstance from '../lib/axios';
// configStore NO importa authStore -> sin ciclo.
import { useConfigStore } from './configStore';

export const useAuthStore = create((set) => ({
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user') || 'null'),

  login: async (email, password) => {
    // Reason: Use axiosInstance for automatic token handling
    const response = await axiosInstance.post('/auth/login', { email, password });
    const { access_token, user } = response.data;

    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(user));

    set({ token: access_token, user });
    return user;
  },

  register: async (email, password) => {
    // Reason: Use axiosInstance for automatic token handling
    const response = await axiosInstance.post('/auth/register', { email, password });
    const { access_token, user } = response.data;

    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(user));

    set({ token: access_token, user });
    return user;
  },

  loginWithGoogle: async (idToken) => {
    // Reason: Reuse the exact same persistence flow as email/password login.
    const response = await axiosInstance.post('/auth/google', { id_token: idToken });
    const { access_token, user } = response.data;

    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(user));

    set({ token: access_token, user });
    return user;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // La llave BYOK es de OpenRouter, de PAGO y del usuario. Quedaba en claro en
    // localStorage tras cerrar sesión: en una máquina compartida (lab, cibercafé)
    // el siguiente usuario heredaba la llave del anterior y gastaba contra su
    // cuenta. Se limpia junto con las preferencias de la sesión.
    localStorage.removeItem('openrouter_api_key');
    localStorage.removeItem('chat_context');
    localStorage.removeItem('chat_history_limit');
    localStorage.removeItem('chat_global');
    // Y el estado EN MEMORIA del configStore (ver clearUserPrefs allí).
    useConfigStore.getState().clearUserPrefs();
    set({ token: null, user: null });
  },

  checkAuth: () => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    set({ token, user });
  }
}));
